import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EnhancementVariantDetail } from 'src/app/models/mastersuites/mastersuite';
import { AlertService } from 'src/app/services/alert.service';
import { MasterSuitesService } from 'src/app/services/mastersuites.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
    selector: 'app-master-suite-dialog',
    templateUrl: './master-suite-dialog.component.html',
    styleUrls: ['./master-suite-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class MasterSuiteDialogComponent implements OnInit {
  enhancementVariants!: EnhancementVariantDetail[];
  isLoading = true;

  enhancementVariantSelected?: EnhancementVariantDetail;
  defaultEnhancementVariant?: EnhancementVariantDetail;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private masterSuitesService: MasterSuitesService,
    private productsService: ProductsService,
    private router: Router,
    public dialogRef: MatDialogRef<MasterSuiteDialogComponent>,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    this.masterSuitesService
      .getAllEnhancementVariantOfMasterSuite(this.dataDialog.masterSuiteId)
      .subscribe({
        next: (res) => this.handleVariantsLoaded(res.enhancementVariants),
        error: () => {
          this.isLoading = false;
          this.dialogRef.close();
        },
      });
  }

  private handleVariantsLoaded(variants: EnhancementVariantDetail[]): void {
    this.enhancementVariants = variants;
    if (variants.length === 0) {
      this.dialogRef.close({ enhancementVariants: [] });
      return;
    }
    if (variants.length === 1) {
      this.enhancementVariantSelected = variants[0];
    }
    if (this.dataDialog.masterSuiteEnhancementVariantId) {
      this.enhancementVariantSelected = this.enhancementVariants.find(
        (en) => en.id === this.dataDialog.masterSuiteEnhancementVariantId,
      );
    }
    this.isLoading = false;
  }

  openMasterSuite(enhancementVariant: EnhancementVariantDetail) {
    this.dialogRef.close();
    this.router.navigate([
      `mastersuites/${this.dataDialog.masterSuiteId}/update/enhancement-variant/${enhancementVariant.id}`,
    ]);
  }

  onSave(): void {
    if (this.dataDialog.isAutoApply) {
      this.closeWithAutoApply();
    } else {
      this.applyAndClose();
    }
  }

  private closeWithAutoApply(): void {
    this.dialogRef.close({
      enhancementVariantSelected: this.enhancementVariantSelected,
    });
  }

  private applyAndClose(): void {
    this.productsService
      .applyEnhancementVariantOnProducts({
        productIds: this.dataDialog.productIds,
        enhancementVariantId: this.enhancementVariantSelected?.id || '',
        version: 0,
      })
      .subscribe({
        next: () => {
          this.alertService.successToast(
            `Select Enhancement Variant ${this.enhancementVariantSelected?.name} successfully!`,
          );
          this.dialogRef.close({
            enhancementVariants: this.enhancementVariants,
            enhancementVariantSelected: this.enhancementVariantSelected,
          });
        },
        error: () => {
          this.dialogRef.close();
        },
      });
  }

  setDefaultEnhancementVariant() {
    this.enhancementVariantSelected = this.enhancementVariants[0];
    this.dialogRef.close({
      enhancementVariantSelected: this.enhancementVariantSelected,
    });
  }
}
